export default __webpack_public_path__ + "static/media/whiteCard.f03b473a.png";